export default __webpack_public_path__ + "static/media/recipe.944b34b4.svg";